(() => {
  if (window.JustNoiseHome) return;
  const statsUrl = 'https://musical-basbousa-75d63c.netlify.app/.netlify/functions/stats';
  const cacheKey = 'community-focus-minutes:v1';
  const controllers = new WeakMap();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function start(root) {
    const hours = root.querySelector('[data-community-hours]');
    if (!hours || controllers.has(root)) return;
    const controller = new AbortController();
    controllers.set(root, controller);
    const video = root.querySelector('.jn-home-community__video');
    if (video) {
      const sync = () => reduced.matches ? video.pause() : video.play().catch(() => {});
      reduced.addEventListener('change', sync, { signal: controller.signal });
      controller.signal.addEventListener('abort', () => video.pause(), { once: true });
      sync();
    }

    function render(minutes) {
      if (controller.signal.aborted || typeof minutes !== 'number' || !Number.isFinite(minutes) || minutes < 0) return false;
      hours.textContent = `${Math.floor(minutes / 60)}h`;
      return true;
    }

    try { render(JSON.parse(localStorage.getItem(cacheKey))); } catch {}

    const timeout = setTimeout(() => controller.abort(), 8000);
    controller.signal.addEventListener('abort', () => clearTimeout(timeout), { once: true });
    fetch(statsUrl, { signal: controller.signal })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        if (!data || !render(data.totalSessionMinutes)) return;
        try { localStorage.setItem(cacheKey, JSON.stringify(data.totalSessionMinutes)); } catch {}
      })
      .catch(() => {})
      .finally(() => clearTimeout(timeout));
  }

  function init(root = document) {
    if (root.matches?.('[data-justnoise-home]')) start(root);
    root.querySelectorAll('[data-justnoise-home]').forEach(start);
  }

  window.JustNoiseHome = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-justnoise-home]').forEach(root => { controllers.get(root)?.abort(); controllers.delete(root); });
  });
})();
